import { render, staticRenderFns } from "./shield.vue?vue&type=template&id=366b624e&scoped=true&"
import script from "./shield.vue?vue&type=script&lang=js&"
export * from "./shield.vue?vue&type=script&lang=js&"
import style0 from "./shield.vue?vue&type=style&index=0&id=366b624e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366b624e",
  null
  
)

export default component.exports